import { Spin, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { GetPlans2, GetRechargeType } from "../../../../ApiServices/Apifun";
import AllPlans2 from "./AllPlans2";

const PlanDetails2 = ({ operator, circle, getAmount, setAllPlans }) => {
  const [tabItems, setTabItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rechargeType, setrechargeType] = useState([]);
  const [selectType, setSelectType] = useState(null);
  const getRechargeType = () => {
    GetRechargeType()
      .then((res) => {
        const rechargeTypeData = res.data.map((item, index) => {
          return {
            label: item.rechargeType,
            value: item.rechargeTypeId,
            key: index,
          };
        });
        setrechargeType(res.data);
      })
      .catch((err) => console.log(err));
  };
  // useEffect(() => {
  //   getRechargeType();
  // }, []);

  // const getAllPlans = async () => {
  //   setLoading(true);

  //   const formdata = new FormData();
  //   formdata.append("operator", operator.value);
  //   formdata.append("circle", circle.value);
  //   formdata.append("recharge_type", selectType);

  //   try {
  //     const res = await GetPlans2(formdata);

  //     const plans = res?.data?.status ? res.data.data : [];

  //     // Group plans by rechargeType
  //     const grouped = plans.reduce((acc, plan) => {
  //       const type = plan.rechargeType || "Other";
  //       if (!acc[type]) acc[type] = [];
  //       acc[type].push(plan);
  //       return acc;
  //     }, {});

  //     // Use rechargeTypeData to create all tabs regardless of available plans
  //     const tabItems = rechargeType.map((type, index) => {
  //       const plansForType = grouped[type.rechargeType] || [];

  //       return {
  //         key: String(type.rechargeTypeId),
  //         label: type.rechargeType,
  //         children:
  //           plansForType.length > 0 ? (
  //             <AllPlans2
  //               group_name={type.rechargeType}
  //               data={plansForType}
  //               setAmount={getAmount}
  //             />
  //           ) : (
  //             <div className="text-center py-4 text-gray-500">
  //               No related plan available
  //             </div>
  //           ),
  //       };
  //     });

  //     setTabItems(tabItems);
  //     setAllPlans(plans);
  //   } catch (err) {
  //     console.error(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  
  const getAllPlans = async () => {
    setLoading(true);

    const formdata = new FormData();
    formdata.append("operator", operator.value);
    formdata.append("circle", circle.value);
    formdata.append("recharge_type", selectType);

    try {
      const res = await GetPlans2(formdata);

      const plans = res?.status ? res?.data : [];

      const normalizeType = (type = "") => {
        const value = type.trim().toUpperCase();
        if (value === "ROMAING") return "ROAMING";
        return value;
      };

      const grouped = plans.reduce((acc, plan) => {
        const type = normalizeType(plan.rechargeType);
        if (!acc[type]) acc[type] = [];
        acc[type].push(plan);
        return acc;
      }, {});

      const uniqueTypes = [
        ...new Set(plans.map((p) => normalizeType(p.rechargeType))),
      ];

      const tabItems = uniqueTypes.map((type, index) => ({
        key: String(index),
        label: type,
        children: (
          <AllPlans2
            group_name={type}
            data={grouped[type]}
            setAmount={getAmount}
          />
        ),
      }));

      setTabItems(tabItems);
      setAllPlans(plans);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getRechargeType();
  }, []);
  useEffect(() => {
    if (operator && circle) {
      getAllPlans();
    }
  }, [operator, circle, selectType]);
  return (
    <>
      {loading && (
        <div className="prepaid col-span-2 flex justify-center items-center font-semibold text-lg w-full h-full bg-white rounded-3xl shadow-normal p-5">
          <Spin
            className={`col-span-2 flex justify-center items-center  ${
              loading && "w-full h-full"
            } `}
            spinning={loading}
          />
        </div>
      )}
      {!loading && tabItems.length ? (
        <>
          <div className="prepaid col-span-2 w-full bg-white rounded-3xl shadow-normal p-5">
            <p className="text-lg font-bold">
              Browse Plan of {operator.text} - {circle.label}
            </p>
            <Tabs
              // defaultActiveKey="1"
              activeKey={selectType}
              items={tabItems}
              onChange={(key) => {
                setSelectType(key);
              }}
            />
          </div>
        </>
      ) : (
        ""
      )}
      {!loading && !tabItems.length && (
        <div className="prepaid col-span-2 flex justify-center items-center font-semibold text-lg w-full h-full bg-white rounded-3xl shadow-normal p-5">
          <p>There is no related plans!</p>
        </div>
      )}
    </>
  );
};

export default PlanDetails2;
